import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class LuFipsAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'fa-lu-fips';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/fips';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'code',
            'state',
            'county',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default LuFipsAppResource;
